import { ApiService } from "./api";
import { selectedFiltersType } from "../reducers/invoicesSlice";

class Invoices {
  get = (queryParams?: selectedFiltersType) => {
    // @ts-ignore
    return ApiService.get(`/finance/customer/invoices/`, {
      params: queryParams,
    });
  };
  getPdfFile = (id: number) => {
    // @ts-ignore
    return ApiService.get(`/finance/customer/invoice_receipt/${id}/`);
  };
  payInvoice = (id: number) => {
    const unlimintBody = {
      payment_type: "card_usd",
      gateway: "unlimint_bankcard",
    };
    // @ts-ignore
    return ApiService.post(
      `/finance/customer/invoice/${id}/payment_url/`,
      unlimintBody
    );
  };
}

export const InvoicesApi = new Invoices();
